export const studyData = [{
        id: 1,
        title: "Exoplanet Prediction Using Kepler Labelled Time Series Data With Machine Learning Algorithms",
        img: "./studyImages/exoplanet.gif",
        modalImage: "",
        author: "Reymond R. Mesuga",
        type: "Personal Project",
        code: "https://github.com/mesuga-reymond/AI_DeepLearning_MachineLearning_Projects/tree/master/8_Searching_for_the_Exo_Planets_Using_Machine_Learning_Algorithms",
        info: "This project is about the prediction of the next possible earth using the light intensity time series data gathered by Kepler space telescope. The models used in this project are Random Forest, XGBoost, and Support Vector Machine Classifier.",
        button_name: "Source Code"
    },
    {
        id: 2,
        title: "Machine Learning Approach on Electron Invariant Mass Prediction Using CERN Electron Collision Data",
        img: "./studyImages/CMS-s_0.jpg",
        author: "Reymond Mesuga",
        type: "Academic Research",
        code: "https://github.com/mesuga-reymond/AI_DeepLearning_MachineLearning_Projects/tree/master/7_Electron_Invariant_Mass_Prediction",
        info: "This personal project aims to predict the invariant mass of electron using CERN Electron Collision Data. The machine learning algorithms to be used are Random Forest Regressor and XGBoost Regressor.",
        button_name: "Source Code"
    },
    {
        id: 3,
        title: "Covid-19 Chest X-Ray Image Classification Using Transfer Learning Model with ResNet50 Base Architecture",
        img: "./studyImages/covid-19.jpg",
        author: "Reymond R. Mesuga",
        type: "Personal Project",
        // code: "https://github.com/mesuga-reymond/Machine_and_Deep_Learning/blob/master/4_Covid-19_Image_Classification/Successful_Resnet50_Covid19_(5_17_21).ipynb",
        info: "The goal of this project is to compare the accuracy of different state of the art models to predict the possible existence of Covid-19 using chest x-ray images.",
        button_name: "Source Code"
    },
    {
        id: 4,
        title: "Alzheimer's Desease Detection Using Different CNN Transfer Learning Model Algorithms",
        img: "./studyImages/MIRScanGIF.gif",
        author: "Reymond Mesuga",
        type: "Personal Project",
        code: "https://github.com/mesuga-reymond/AI_DeepLearning_MachineLearning_Projects/tree/master/3_Alzheimers_Detection",
        info: "This project aims to evaluate the performance of different state of the start transfer learning model to detect different stages of Alzheimer's Desease using MRI brain scans.",
        button_name: "Source Code"
    },
    {
        id: 5,
        title: "Histopathologic Cancer Detection Using ConvNet with InceptionV3 Base Architecture",
        img: "./studyImages/histopathologic.jpg",
        modalImage: "",
        author: "Reymond R. Mesuga",
        type: "Personal Project",
        code: "https://github.com/mesuga-reymond/AI_DeepLearning_MachineLearning_Projects/tree/master/6_Histopathologic-Cancer-Detection",
        info: "This is a personal project that focuses on creating an algorithm to detect histopathologic cancer using ConvNet with InceptionV3 base architecture model in small image patches taken from larger digital pathology scans.",
        button_name: "Source Code"
    },
    {
        id: 6,
        title: "Pneumonia Image Classification Using CNN with ResNet9 Architecture",
        img: "./studyImages/pneumonia-xray.jpeg",
        author: "Reymond R. Mesuga",
        type: "Personal Project",
        button_name: "Source Code",
        code: "https://github.com/mesuga-reymond/AI_DeepLearning_MachineLearning_Projects/tree/master/1_Pneumonia_Image_Classification_Using_CNN",
        info: "This is a pneumonia classifier model in CNN with ResNet9 architecture using PyTorch. The CNN model here was built and trained from the ground that has an accuracy of approximately 85%."
    },
];

export const studyDataForLarge = [{
        id: 7,
        title: "Investigation on the Effects of Digital Radiographic Image Qualities on the Performance of Convolutional Neural Networks (CNNs) for COVID-19 Likelihood Prediction ",
        img: "./studyImages/covid-xray-manipulation.jpg",
        author: "Reymond Mesuga*, Cloyd Raymond Pernes and Luther Villacruz",
        // corresponding_author: "✞Corr. Author: rrmesuga@iskolarngbayan.pup.edu.ph",
        type: "Academic Research",
        button_name: "Read Story",
        code: "https://github.com/mesuga-reymond/Machine_and_Deep_Learning/tree/master/4_Covid-19_Image_Classification",
        info: "This academic research aims to investigate the effects of image quality on the accuracy of CNN to predict the possible existence of Covid-19 virus on x-ray images. This will be observed by manipulating images at different image quality distortions. The outcomes of this study may give insights to improve both medical imaging technologies and deep learning algorithms."
    },
    {
        id: 8,
        title: "A Deep Transfer Learning Approach on Identifying Glitch Wave-form in Gravitational Wave Data",
        img: "./studyImages/black-hole-smush_600.gif",
        author: "Reymond Mesuga and Brian James Bayanay",
        // corresponding_author: "rrmesuga@iskolarngbayan.pup.edu.ph",
        type: "Academic Research",
        button_name: "Source Code",
        code: "https://github.com/mesuga-reymond/Gravitational_Wave_Laboratory_Project_2021_Mesuga_Bayanay",
        info: "This academic research aims to compare different state-of-the-art CNN architectures to classify glitches detected by LIGO. The outcomes of this research may give insights to improve current CNN models for future benefits of LIGO."
    },
]

export const studyData1 = [
    {
        id: 10,
        title: "Covid-19 Exploratory Data Analysis Using Python",
        img: "./studyImages/covidGIF.gif",
        modalImage: "",
        author: "Reymond R. Mesuga",
        type: "Personal Project",
        button_name: "Source Code",
        code: "https://github.com/mesuga-reymond/Data_Analysis_Projects/tree/master/Covid_19_Data_Analysis",
        info: "This project is divided into two parts. First is about ranking analysis of countries in terms of total cases. Second is about relationship between health indicators and total Covid-19 cases."
    },
    {
        id: 11,
        title: "Water Potability Prediction Using Machine Learning Algorithms",
        img: "./studyImages/water_potability.jpg",
        modalImage: "",
        author: "Reymond R. Mesuga",
        type: "Personal Project",
        button_name: "Source Code",
        code: "https://github.com/mesuga-reymond/AI_DeepLearning_MachineLearning_Projects/blob/master/9_Water_Quality_Potability_Prediction/Water_Potability_Prediction_Using_Machine_Learning_Algorithms.ipynb",
        info: "This is a machine learning project aims to predict water potality of the water. Water potality indicates if the water quality is safe for human consumption or not. The models used are Random Forest, XGBoost, and Support Vector Machine."
    },
    {
        id: 12,
        title: "Pulsar Star Prediction Using High Time Resolution Universe Survey Data with Machine Learning Algorithms",
        img: "./studyImages/pulsar_magnetosphere_model_web.gif",
        modalImage: "",
        author: "Reymond R. Mesuga",
        type: "Personal Project",
        button_name: "Source Code",
        code: "https://github.com/mesuga-reymond/AI_DeepLearning_MachineLearning_Projects/tree/master/11_Pulsar_Star_Prediction",
        info: "This is a machine learning binary classification project that aims to classify whether an input indicates a pulsar star or not. The machine learning algorithms to be used are Random Forest, XGBoost and Support Vector Machine."
    },
    {
        id: 13,
        title: "Ship Classification in Satellite Images Using Deep Transfer Learning Model with Resnet50 Base Architecture",
        img: "./studyImages/1_Suez-Canal_WV2_EUSI.jpg",
        modalImage: "",
        author: "Reymond R. Mesuga",
        type: "Personal Project",
        button_name: "Source Code",
        code: "https://github.com/mesuga-reymond/AI_DeepLearning_MachineLearning_Projects/tree/master/10_Ship_Classification_Using_Satellite_Images",
        info: "This is a binary classification machine learning project aims to classify whether there is a ship on a satellite image or not. The dataset to be used was gathered from the recorded satellite images of ships in San Francisco. "
    },
    {
        id: 14,
        title: "Incremental Learning Approach on Higgs Bosson Signal Detection",
        img: "https://i.cbc.ca/1.1558449.1379047730!/httpImage/image.jpg_gen/derivatives/16x9_780/hi-particle-852-cp-02904495-8col.jpg",
        modalImage: "",
        author: "Reymond R. Mesuga",
        type: "Personal Project",
        button_name: "Ongoing",
        code: "",
        info: "This study demonstrates the use of incrementally learned artificial intelligence algorithms on detecting exotic particles in high-energy physics. Incremental learning is said to be beneficial on handling very large data comparable to the data being produced by LHC."
    },
    {
        id: 15,
        title: "CoVision19: An Artificial Intelligence-Based Software for COVID-19 Likelihood Prediction Using the Combination of X-ray and Symptoms Data",
        img: "https://i.cbc.ca/1.1558449.1379047730!/httpImage/image.jpg_gen/derivatives/16x9_780/hi-particle-852-cp-02904495-8col.jpg",
        modalImage: "",
        author: "R. Mesuga*, C.R. Pernes, L. Villacruz, and M.A. Burgonio, MSc.",
        type: "Personal Project",
        button_name: "Ongoing",
        code: "",
        info: "CoVision19 is a desktop software that combines the x-ray and symtoms data to predict COVID-19. This software has build-in deep learning and machine learning models responsible for prediction."
    },
]